import { parse, format, eachMonthOfInterval } from "date-fns";
import { DateFormats } from "./display.ts";

export const yearMonthParser = (value: string) =>
  parse(value, DateFormats.YEAR_MONTH, new Date());

/**
 * Parses a string value based on a format, without throwing any errors
 * and returning a default value in case of an error or parsing issue
 * @param value Value that should be parsed
 * @param format Format that should be used for parsing
 * @param defaultDate If parsing fails, this default value will be used
 * @returns an `object: {parsed: Date, successful: boolean}`
 */
export const safeDateParser = (
  value: string,
  format: string,
  defaultDate: Date
): { parsed: Date; successful: boolean } => {
  const parsed = parse(value, format, new Date());
  try {
    if (parsed instanceof Date && !isNaN(parsed.getTime())) {
      return { parsed, successful: true };
    }
  } catch (_) {
    return { parsed: defaultDate, successful: false };
  }
  return { parsed: defaultDate, successful: false };
};

export const getDiscreteYearMonths = (
  startYearMonth: string,
  endYearMonth: string
) => {
  const start = yearMonthParser(startYearMonth);
  const end = yearMonthParser(endYearMonth);
  return eachMonthOfInterval({ start, end }).map((date) =>
    format(date, DateFormats.YEAR_MONTH)
  );
};
